import { useEffect, useState } from 'react'

/**
 * Whether the browser thinks it has a connection.
 *
 * `navigator.onLine` is the browser's own guess and it is a generous one — a captive portal or a dead
 * upstream both read as online. It is right often enough to tell a visitor why a video will not play,
 * and everything that depends on it degrades to a network fetch if it is wrong.
 */
export const useOnline = (): boolean => {
	const [online, setOnline] = useState(() => navigator.onLine !== false)

	useEffect(() => {
		const update = () => setOnline(navigator.onLine !== false)

		window.addEventListener('online', update)
		window.addEventListener('offline', update)
		update()

		return () => {
			window.removeEventListener('online', update)
			window.removeEventListener('offline', update)
		}
	}, [])

	return online
}
